import {
    GET_CURRENT_EQUIPMENT
} from './constants';

const initialState = {
    currentEquipment: {},
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_CURRENT_EQUIPMENT: {
            return {
                ...state,
                currentEquipment: action.payload,
            };
        }
        default:
            return state;
    }
};

